import React from 'react';

const Header = () => (
  <div>
    <h1>This is a header</h1>
  </div>

);
export default Header;
